import type { GeoLocation } from '@bambi/api-client/schemas';
import { createColumnHelper } from '@tanstack/react-table';
import { capitalize } from 'lodash-es';

import SourceColumnFilter from './filters/SourceColumnFilter';
import { RowActions } from './RowActions';
import store from 'src/app/store/store';
import { setGeolocationSourceFilter } from 'src/features/settings/setting.slice';

const columnHelper = createColumnHelper<GeoLocation>();

export const columns = [
  columnHelper.accessor('label', {
    id: 'label',
    header: 'Label',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('location.municipality', {
    id: 'city',
    header: 'City',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('location.region', {
    id: 'state',
    header: 'State',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('location.postal_code', {
    id: 'zip_code',
    header: 'Zip Code',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('location.latitude', {
    id: 'latitude',
    header: 'Latitude',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('location.longitude', {
    id: 'longitude',
    header: 'Longitude',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('trip_count', {
    id: 'trip_count',
    header: 'Trip Count',
    cell: ({ getValue }) => getValue(),
  }),
  columnHelper.accessor('source', {
    id: 'source',
    header: 'Source',
    cell: ({ getValue }) => {
      return capitalize(getValue());
    },
    meta: {
      filterComponent(column, open, onClose) {
        return (
          <SourceColumnFilter
            open={open}
            onClose={onClose}
            selected={store.getState().setting.geolocationSourceFilter}
            onApply={(sources) => {
              store.dispatch(setGeolocationSourceFilter(sources));
            }}
            triggerElement={<div />}
          />
        );
      },
      filterCount() {
        const state = store.getState().setting;
        return state.geolocationSourceFilter.length || 0;
      },
    },
  }),
  columnHelper.display({
    id: 'edit',
    header: 'Edit',
    cell: ({ row }) => <RowActions geolocation={row.original} />,
  }),
];
